import 'rxjs/add/operator/map';

import { Injectable } from '@angular/core';
import { MdDialog } from '@angular/material';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

/* Importing local components/modules starts */
import { Enum } from '../../utility/enum.enum';
import { AppMessage } from './../../Common/appMessage';
import { AppGlobals } from './../../Common/Services/app.global';
import { SharedService } from './../../Common/Services/shared.service';
import { DialogConfirmComponentComponent } from './../../Components/dialog-confirm-component/dialog-confirm-component.component';
import { Menu } from '../../utility/menu';
import { examTypeOptions} from "../../Common/appConstant";
/* Importing local components/modules ends */

@Injectable()
export class Utility {
    leftMenusList = Menu.leftMenusList;
    leftMenusList_CUser = null;

    days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']; // Sequence of days which we are using everywhere (see Location Setting)
    private listSubject = new Subject<any>();
    private txnSubject = new Subject<any>();
    private loaderSubject = new Subject<any>();
    private readyForMasterSubject = new Subject<any>();
    private userLoggedInSubject = new Subject<any>();
    private loaderCount = 0;
    private notificationSubject = new Subject<any>();
    private notificationCount = 0;
    private readyForMaster: boolean = false;
    private isUserLoggedIn: boolean = false;
    selectedCountry: string = "";
    authenticateUserRoute: string = "AuthenticateUser";

    toggle_my_Class = 'inactive'; //hide-show notification dropdown for candidate

    showGradientBandAtTop: boolean = false;

    // Sequence of days with its Id as used everywhere (see Operational hours)
    weekdays = [
        { name: "Sunday", Id: 1 },
        { name: "Monday", Id: 2 },
        { name: "Tuesday", Id: 3 },
        { name: "Wednesday", Id: 4 },
        { name: "Thursday", Id: 5 },
        { name: "Friday", Id: 6 },
        { name: "Saturday", Id: 7 }
    ]
    private valuesPolyfill = function values(object) {
        return Object.keys(object).map(key => object[key]);
    };

    objValues = (<any>Object).values || this.valuesPolyfill; // Object.values does not work in IE browser so use function for that.

    constructor(private _appGlobals: AppGlobals, private _sharedService: SharedService
        , public _dialog: MdDialog, private _appMessage: AppMessage,
        private _router: Router) {
    }

    clearList() {
        this.listSubject.next([]);
    }

    getList(): Observable<any> {
        return this.listSubject.asObservable();
    }

    setTxnStatus(newVal: any) {
        this.txnSubject.next(newVal);
    }

    clearTxnStatus() {
        this.txnSubject.next(false);
    }

    getTxnStatus(): Observable<any> {
        return this.txnSubject.asObservable();
    }

    getLoaderStatus(): Observable<any> {
        return this.loaderSubject.asObservable();
    }

    addLoaderCount() {
        this.loaderCount++;
        this.loaderSubject.next({ lCount: this.loaderCount });
    }

    removeLoaderCount() {
        if (this.loaderCount > 0) {
            this.loaderCount--;
        }
        this.loaderSubject.next({ lCount: this.loaderCount });
    }

    clearLoaderCount() {
        this.loaderCount = 0;
        this.loaderSubject.next(this.loaderCount);
    }

    getNotificationStatus(): Observable<any> {
        return this.notificationSubject.asObservable();
    }

    addNotificationCount() {
        this.notificationCount++;
        this.notificationSubject.next({ nCount: this.notificationCount });
    }

    removeNotificationCount() {
        if (this.notificationCount > 0) {
            this.notificationCount--;
        }
        this.notificationSubject.next({ nCount: this.notificationCount });
    }

    clearNotificationCount() {
        this.notificationCount = 0;
        this.notificationSubject.next({ nCount: this.notificationCount });
    }

    setNotificationCount(nCounts: number) {
        if (nCounts >= 0) {
            this.notificationCount = nCounts;
            this.notificationSubject.next({ nCount: this.notificationCount });
        }
    }

    getReadyForMasterStatus(): Observable<any> {
        return this.readyForMasterSubject.asObservable();
    }

    setReadyForMasterStatus(newStatus: boolean = false) {
        this.readyForMaster = newStatus;
        this.loaderSubject.next(this.readyForMaster);
    }

    getUserLoggedInStatus(): Observable<any> {
        return this.userLoggedInSubject.asObservable();
    }

    setUserLoggedInStatus(newStatus: boolean = false) {
        this.isUserLoggedIn = newStatus;
        this.userLoggedInSubject.next(this.isUserLoggedIn);
    }

    getAccessTokenInLS() {
        return this.getFromLStorage('individualexamschedulerAccessToken', 'str');
    }

    setAccessTokenInLS(token: string) {
        if (token && token != null && token != "") {
            this.setInLStorage('individualexamschedulerAccessToken', 'str', token);
        }
    }

    setInLStorage(key: string, valueType: string, value: any): any {
        let valToSet: string;
        if (valueType == "obj") {
            valToSet = JSON.stringify(value);
        }
        else {
            valToSet = value;
        }
        localStorage.setItem(key, valToSet);
        return true;
    }

    getFromLStorage(key: string, valueType: string): any {
        let retVal: any;
        retVal = localStorage.getItem(key);
        if (retVal == null) {
            return retVal;
        }
        if (valueType == "obj") {
            retVal = JSON.parse(retVal);
        }
        return retVal;
    }

    removeFromLStorage(key: string): void {
        localStorage.removeItem(key);
    }

    /**
     *  to convert date/time/date-time in string format [yyyy-MM-dd]
     * @param dateVal type: Date
     * @param type type:string ('d' for date only, 't' for time only, 'dt' for date-time)
     */
    convertToDateStr(dateVal: Date, type: string = 'dt'): string {
        let retStr = null;
        try {
            let dateStr = dateVal.getFullYear()
                + "-" + ((dateVal.getMonth() + 1) >= 10 ? (dateVal.getMonth() + 1) : '0' + (dateVal.getMonth() + 1))
                + "-" + (dateVal.getDate() >= 10 ? dateVal.getDate() : '0' + dateVal.getDate());
            let timeStr = dateVal.getHours() >= 10 ? dateVal.getHours() : ('0' + dateVal.getHours());
            timeStr += ":" + (dateVal.getMinutes() >= 10 ? dateVal.getMinutes().toString() : ('0' + dateVal.getMinutes().toString()));
            timeStr += ":" + (dateVal.getSeconds() >= 10 ? dateVal.getSeconds().toString() : ('0' + dateVal.getSeconds().toString()));
            if (type == 'd') {
                retStr = dateStr;
            }
            else if (type == 't') {
                retStr = timeStr;
            }
            else {
                retStr = dateStr + ' ' + timeStr;
            }
        }
        catch (Error) {
        }
        return retStr;
    }

    // to convert datetime string in system datetime
    convertToDateTime(dateStr): Date {
        let retDate = new Date();
        try {
            let tempList = dateStr.split(' ');
            let datePart = tempList.length > 0 ? tempList[0] : null;
            let timePart = tempList.length > 1 ? tempList[1] : null;
            if (datePart != null) {
                datePart = datePart.split('-');
                retDate = new Date(datePart[0].toString(), datePart[1] - 1, datePart[2].toString());
                if (timePart != null) {
                    timePart = timePart.split(':');
                    retDate = new Date(datePart[0], datePart[1] - 1, datePart[2], timePart.length >= 1 ? timePart[0] : 0, timePart.length >= 2 ? timePart[1] : 0, timePart.length >= 3 ? timePart[2] : 0);
                }
            }
        }
        catch (Error) {
            retDate = new Date();
        }
        return retDate;
    }

    // to show long string in dotted format in html
    getShortStr(str = '', maxLength): string {
        let retStr = str;
        if (retStr != null && retStr != '') {
            if (str.length > maxLength) {
                retStr = str.substr(0, maxLength - 3) + '...';
            }
        }
        return retStr;
    }

    //convert case of string that can be used in html as toUpperCase() can not be directly used in html
    convertToCase(str: string = '', newCase: string = 'l'): string {
        let retVal = str;
        if (retVal != null && retVal != '') {
            if (newCase == 'u') {
                retVal = retVal.toUpperCase();
            }
            else {
                retVal = retVal.toLowerCase();
            }
        }
        return retVal;
    }

    daysUntil(date) {
      let days = Math.round((new Date(date).getTime() - new Date().getTime()) / (24 * 60 * 60 * 1000));
      return days > 0 ? days : 0;
    }

    // Call this method to add two durations
    // format:  hh:mm:ss
    addDuration(firstDuration, secondDuration, ssShow = false): string {
        if (!firstDuration || !secondDuration) {
            return '';
        };
        let times = [];
        let times1 = firstDuration.split(':');
        let times2 = secondDuration.split(':');

        for (let i = 0; i < 3; i++) {
            times1[i] = (isNaN(parseInt(times1[i]))) ? 0 : parseInt(times1[i]);
            times2[i] = (isNaN(parseInt(times2[i]))) ? 0 : parseInt(times2[i]);
            times[i] = times1[i] + times2[i];
        }

        let seconds = times[2];
        let minutes = times[1];
        let hours = times[0];

        if ((seconds / 60) >= 1) {
            minutes += Math.floor(seconds / 60);
            seconds = Math.floor(seconds % 60);
        }

        if ((minutes / 60) >= 1) {
            hours += Math.floor(minutes / 60);
            minutes = Math.floor(minutes % 60);
        }
        // hours = (hours.toString().length == 1) ? '0' + hours : hours;
        // minutes = (minutes.toString().length == 1) ? '0' + minutes : minutes;
        //  seconds = (seconds.toString().length == 1) ? '0' + seconds : seconds;
        // if (ssShow) {
        //     return hours + ':' + minutes + ':' + seconds;
        // }
        // else {
        //     return hours + ':' + minutes;
        // }
        let retVal = hours + ':' + minutes;
        //alert(retVal);
        return retVal;
    }

    // Disable Enable Form fields
    disableEnableForm(form: any, disable: boolean) {
        if (form) {
            disable ? form.disable() : form.enable();
        }
    }

    /**
 * Fetch record based on Id
 * @param model  - autocomplete or combo Field name prefix like region, country, state...
 * @param id - get record of this id param
 */
    getRecordById(model: string, id: number): any {
        let data = this._sharedService[model + "List"];
        if (model && data && data.length > 0) {
            let item = data.filter((item) => { if (item.id == id) return item });
            return item[0];
        }
    }

    /**
     *
     * @param data - data on which we have to filter
     * @param name - value which you have typed in autocomplete field
     */
    filterItems(data: any, name: string) {
        // check whether locationAddress property does exist or not, if yes then compare with both name & locationAddress
        if (data && data.length > 0 && data[0].name && data[0].locationAddress) {
            return data.filter(item => {
                // if (item.name.toString().toLowerCase().startsWith(name.toString().toLowerCase()) ||
                //     (item.locationAddress && item.locationAddress.toString().toLowerCase().startsWith(name.toString().toLowerCase()))) {
                if (item.name.toString().toLowerCase().indexOf(name.toString().toLowerCase()) > -1 ||
                    (item.locationAddress && item.locationAddress.toString().toLowerCase().indexOf(name.toString().toLowerCase())) > -1) {
                    return item;
                }
            }
            );
        }
        // else compare with name only
        else if (data && data.length > 0 && data[0].name) {
            return data.filter(item => {
                // new RegExp(`^${name}`, 'gi').test(item.name)
                if (item.name.toString().toLowerCase().indexOf(name.toString().toLowerCase()) > -1) {
                    return item;
                }
            }
            );
        }
    }

    /**
     * To set data in auto complete field , call this function
     * @param model - This is field name prefix like region , state, location , country, city etc..We have used this to create dynamic field for FilteredOptions
     * @param customData  - this is customDdata - a custom data which we have to set in the field. (Pass this param as null if you don't need of it)
     * @param control  - form control name
     * @param me  - scope of that component
     */
    setDataInComboField(model: string, customData: any, control: any, me: any) {
        let allData = [];
        if (customData && customData.length > -1) {
            allData = customData;
        } else {
            allData = this._sharedService[model + "List"]; // If no any custom data is passed get all data from service itself
        }
        me[model + "valueUpdated"] = allData;
        if (model && allData && allData.length > -1) {
            me[model + "FilteredOptions"] = control.valueChanges
                .startWith(null)
                .map(i => i && i === 'object' ? i.name : i)
                .map(name => name ? this.filterItems(allData, name) : allData.slice());
        }
    }

    /**
     * @param response - complete response object
     * @param customMessage  - custom message which you have to display, In case if you don't need of custom messge , pass it null
     * @param fn - call back function
     * @param isLoaderStart - loader is started or not, if value is true loader count would be removed
     */
    onSuccessCallback(response: any, customMessage: string = null, fn?: any, isLoaderStart: boolean = true) {
        try {
            if (this._dialog.openDialogs.length > 1) {
                this._dialog.openDialogs.pop();
            }
            let code = response.responseCode.toUpperCase();

            if (code == 'S0001') { // success
                // Display alert box if custom message come in params
                if (customMessage) {
                    let OkMsgDialogRefModel = {
                        modelType: "SUCCESS",
                        msgTitle: 'Success',
                        msg: customMessage,
                        showDefaultBtn: true,
                        defaultBtnCaption: 'OK'
                    };
                    let OkMsgDialogRef = this._dialog.open(DialogConfirmComponentComponent, { data: OkMsgDialogRefModel })
                        .afterClosed().subscribe(result => {
                            if (fn) {
                                return fn(result);
                            }
                        });
                } else if (fn) {
                  return fn();
                }
            }
            // if the token is missing or they don't have access, call logout and redirect to "Access Denied Page"
            else if (code == "E1009" || code == "E1166") {
                this._appGlobals.isInvalidToken = true;
                this.logoutUser(false);
            }
            // if token is expired or invalid, call logout to redirect to Login Page
            else if (code == "E1018" || code == "E1007") {
                this._appGlobals.isInvalidToken = true;
                // Try logging them in again to fix their session
                this._appGlobals.logoutURL.next(
                  this._appGlobals.baseURL.getValue() + 'externaluser/login'
                );
                this.logoutUser(true);
            }
            //TODO: need to update this throughout according to JiraID:2079
            // check for E1055 is done for mng pending approvals screen
            else if (code == "E1055") {
                return;
            }
            else {
                let OkMsgDialogRefModel = {
                    modelType: "ERROR",
                    msgTitle: 'Oops!',
                    msg: '',
                    showDefaultBtn: true,
                    defaultBtnCaption: 'OK'
                };
                OkMsgDialogRefModel.msg =
                    this._appMessage.getItem[response.responseCode] == null
                        ? response.responseDescription ? response.responseDescription : this._appMessage.getItem['Common005']//msg from api : something went wrong
                        : this._appMessage.getItem[response.responseCode]; // other message

                if (code == 'E0001') { // Failed
                    OkMsgDialogRefModel.msg = customMessage;
                }
                if (code == 'P0001') { // Partial success
                    OkMsgDialogRefModel.msg = customMessage;
                    let OkMsgDialogRef = this._dialog.open(DialogConfirmComponentComponent, { data: OkMsgDialogRefModel })
                        .afterClosed().subscribe(result => {
                            if (fn)
                                return fn(result);
                        });
                    return;
                }
                let OkMsgDialogRef = this._dialog.open(DialogConfirmComponentComponent, { data: OkMsgDialogRefModel });
            }
        }
        catch (Exception) {
        }
        finally {
            if (isLoaderStart == true) {
                this.removeLoaderCount();
            }
        }
    }


    // fn is callback : ? tell that it is optional parameter
    onErrorCallback(error, fn?, isLoaderStart: boolean = true) {
        try {
            this._dialog.openDialogs.pop();
            // Check for Invalid token, so logout the user
            if (JSON.parse(error).responseCode == "E1007" || JSON.parse(error).responseCode == "E1018") {
                // Invalid token, so logout the user
                this.logoutUser();
            }
            else {
                let ErrorMsgDialogRefModel = {
                    modelType: "ERROR",
                    msgTitle: 'Oops!',
                    msg: JSON.parse(error).responseDescription,
                    showDefaultBtn: true,
                    defaultBtnCaption: 'OK'
                };
                let ErrorMsgDialogRef = this._dialog.open(DialogConfirmComponentComponent,
                    {
                        data: ErrorMsgDialogRefModel
                    });
            }
            // if (fn) {
            //     return fn();
            // }
        }
        catch (Exception) {
        }
        finally {
            if (isLoaderStart == true) {
                this.removeLoaderCount();
            }
            if (fn) {
                return fn();
            }
        }
    }

    /**
     * This function is called in case of Save  , Update
     * To format form Combo Fields data (get Ids from Object for combo fields)
     */
    manageFormDataforSave(formData: Object) {
        if (formData) {
            let fields = Object.keys(formData);
            // Create specific data which are required to send "SAVE / UPDATE" request
            fields.forEach(element => {
                // Number(element) == NaN  -- added this condition because we have some form group with Name 0,1,2...(where we have added dynamic form groups) And we dont need to perform operation for them
                if (element && typeof formData[element] == "object" && !Number(element)) {
                    // If there are sub child in a child element
                    if (formData[element] && formData[element].length) {
                        let subchilds = formData[element];
                        subchilds.forEach((subElement, index) => {
                            if (typeof subElement == "object" && subElement.id)
                                subchilds[index] = subElement.id;
                        });
                    } else if (formData[element] && formData[element].id) {
                        formData[element] = formData[element].id;
                    }
                }
            });
        }
        return formData;
    }

    /**
     * Based On city and state selected, Update timezone field Field name is consist that is timezone
     * @param value
     * @param me
     */
    setTimeZone(value: any, me) {
        if (me.formControl.stateId.value && me.formControl.cityId.value) {
            // timezone
            let id = me.formControl.cityId.value.id;
            if (id) {
                let param = "?outputType=" + Enum.TimeZone + "&id=" + id + "&inputType=" + Enum.City;
                this._sharedService.requestDataForCombo(param).subscribe((response: any) => {
                    this.onSuccessCallback(response, null, () => {
                        me.formControl.timezone.setValue(response.response.results[0].name);
                    });
                })
            } else {
                me.formControl.timezone.setValue('');
            }
        } else {
            me.formControl.timezone.setValue('');
        }
        return;
    }

    // Call this method to set format to 00:00/00:00:00
    setTimeFormat(time: string, ssShow: boolean = true): string {
        let retVal = time;
        if (time != null && time != '') {
            let tempList = time.split(':');
            retVal = '';
            for (let count = 0; count < tempList.length; count++) {
                if (ssShow == true || count < 2) {
                    if (retVal != null && retVal.length > 0) {
                        retVal += ':';
                    }
                    retVal += (tempList[count] != null && tempList[count].toString().length < 2) ? ('0' + tempList[count].toString()) : tempList[count].toString();
                }
            }
        }
        return retVal;
    }


    /**
    * If we change value of combo field and that is not exists in auto fill data then disable update or save button
      If field is invalid then return "true" else return "false"
    */
    disableSaveUpdate(form: any): boolean {
        let isDisable = true;

        if (form.disabled)
            return isDisable; // if form is disabled then return true

        let controls = form.controls;
        let fields = Object.keys(controls);
        for (let i = 0; i < fields.length; i++) {
            let field = fields[i];
            if (field.toLowerCase().substring(field.length - 2, field.length) == "id") { // dropdown fields
                let control = controls[field];
                if (control && control.enabled && control.value) {
                    let id = control.value.id;
                    if (!id) {
                        isDisable = true;
                        return isDisable;
                    } else {
                        isDisable = false;
                    }
                }
            }
        }
        return isDisable;
    }


    // Show the Messages (Success/Error/Validation)
    showDialogMsg(message, msgType = "ERROR", msgTitle = this._appMessage.getItem['Common010'], showDefaultBtn = true, defaultBtnCaption = this._appMessage.getItem['Common011']) {
        let msgDialogRefModel = {
            modelType: msgType,
            msgTitle: msgTitle,
            msg: message,
            showDefaultBtn: showDefaultBtn,
            defaultBtnCaption: defaultBtnCaption
        };
        let msgDialogRef = this._dialog.open(DialogConfirmComponentComponent,
            {
                data: msgDialogRefModel
            });
    }

    /**
     * This function is required to set Name value in autocomplete combo fields
     * we are doing this because for Cascading combo and for save / update we need Id and for display we need Name property
     * @param option - This parameter contains object like {name: 'test', id: 1}
     */
    displayFn(option): string {
        if (option && option.hasOwnProperty('name')) {
            return option.name;
        }
        if (option && option.hasOwnProperty('showStr')) {
            return option.showStr;
        }
    }


    /**
     *
     * @param userId - admin user id for which you have to do retire
     * @param roleType - Role type is global admin , site admin or regional admin - we have to display message based on this
     * @param activate -  pass true if we have to activate User else pass false to retire user
     * @param fn - call bacnk function so that we can handle our logic after successfully retired
     */
    doRetireActiveAdmin(userId: number, roleType: number, activate: boolean, fn): void {
        let param = { "identityId": userId, "identityType": Enum.IdentityType_Admin, "status": activate ? Enum.StatusActive : Enum.StatusRetire };
        let successMsg = activate ? this._appMessage.getItem['UMsg00081'] : this._appMessage.getItem['UMsg00032'];
        let role;
        if (roleType == Enum.RoleTypeRegionalAdmin) {
            role = "Regional Administrator";
        } else if (roleType == Enum.RoleTypeGlobalAdmin) {
            role = "Global Administrator";
        } else {
            role = "Site Administrator";
        }

        successMsg = role + " " + successMsg;

        let confirmDialogMsgModel = {
            modelType: "CONFIRMATION",
            msgTitle: this._appMessage.getItem['Common007'],//'Are you sure',
            msg: activate ? this._appMessage.getItem['UMsg00082'] : this._appMessage.getItem['UMsg00049'],//'Select Yes to retire this Administrator.',
            isConfirmBox: true,
            confirmBtnCaption: this._appMessage.getItem['Common014'],//'Yes',
            cancelBtnCaption: this._appMessage.getItem['Common015'],//'No'
        };
        let confirmDialogMsgRef = this._dialog.open(DialogConfirmComponentComponent,
            {
                data: confirmDialogMsgModel
            });
        confirmDialogMsgRef.afterClosed().subscribe(result => {
            if (result == "1") {
                this.addLoaderCount();
                this._sharedService.retireActivateAdmin(param).subscribe(data => {
                    this.onSuccessCallback(data, successMsg, function () {
                        return fn();
                    });

                },
                    error => {
                        this.onErrorCallback(error);
                    }
                );
            }
        });
    }

    findByMatchingProperties(set, properties) {
        return set.filter(function (entry) {
            return Object.keys(properties).every(function (key) {
                return entry[key] === properties[key];
            });
        });
    }

    /**
     * By this function we are manage Combo fields data which we have to set on form
     * In Get request we are getting Ids of combo fields like region, country etc.. so by this function we will get there name also
     * @param data - Response which coming from request
     */
    manageFormComboData(data: any, customPropertyMapList?: any) {
        if (data && data.id) {
            // For all combo fields fetch {Name and Id} from saved data based on coming Id and Update response
            let fields = Object.keys(data);
            for (var i = 0; i < fields.length; i++) {
                let field = fields[i];
                if (customPropertyMapList && customPropertyMapList.length > 0) {
                    let tempCustomPropertyMap = customPropertyMapList.filter(item => item.field == field)[0];
                    if (tempCustomPropertyMap) {
                        data[tempCustomPropertyMap.map] = data[field];
                        field = tempCustomPropertyMap.map;
                    }
                }
                if (field.toLowerCase().substring(field.length - 2, field.length) == "id" && data[field]) {
                    let prefix = field.substring(0, field.length - 2);
                    if (prefix) {
                        if (typeof data[field] == 'object' && data[field].length > 0) { // If there are muliple values lie approverCountry etc.. (Multi selection field)

                            if (prefix.toLowerCase() == 'approvercountry') { // custom condition for approver country field
                                prefix = 'country';
                            }
                            let subchilds = data[field];
                            subchilds.forEach((subElement, index) => {
                                let obj = this.getRecordById(prefix, subElement);
                                if (obj)
                                    subchilds[index] = obj;
                            });
                        }
                        else {
                            let obj = this.getRecordById(prefix, data[field]);
                            if (obj) {
                                data[field] = obj;
                            }
                        }
                    }
                }
            }
        }
        return data;
    }

    /**
     *
     * @param fn - If click on confirm then this call back function executes
     * @param cancelFn  -- If click on cancel then this call back function executes
     */
    showUnsavedChangesConfirmBox(fn?: any, cancelFn?: any) {
        let confirmDialogMsgModel = {
            modelType: "CONFIRMATION",
            msgTitle: 'Are you sure?',
            msg: 'You have not saved your changes! You will lose any unsaved data. Do you wish to continue?',
            isConfirmBox: true,
            confirmBtnCaption: 'Confirm',
            cancelBtnCaption: 'Cancel'
        };
        let confirmDialogMsgRef = this._dialog.open(DialogConfirmComponentComponent,
            {
                data: confirmDialogMsgModel
            });
        confirmDialogMsgRef.afterClosed().subscribe(result => {
            if (result == "1") {
                this.clearTxnStatus();
                return fn();
            } else if
                 (cancelFn) {
                return cancelFn();
            }
        });
    }

    // To generate the showtext of Operational Hours
    getOperationalHours(opHoursObj: any, cDate: any = null) {
        let retVal = "";
        if (opHoursObj && opHoursObj.length) {
            for (let hCount = 0; hCount < opHoursObj.length; hCount++) {
                if (cDate == null || cDate == "") {
                    if (retVal.length > 0) {
                        retVal += ', ';
                    }
                    retVal += this.days[opHoursObj[hCount].weekDay - 1] + ": " + opHoursObj[hCount].startTime + "-" + opHoursObj[hCount].endTime;
                } else if (new Date(cDate).getUTCDay() == opHoursObj[hCount].weekDay - 1) {
                    retVal = opHoursObj[hCount].startTime + "-" + opHoursObj[hCount].endTime;
                }
            }
        }
        return retVal;
    }

    /**
     * Function check for duplicates names in admin data, If there are two same names on that case we have to display unique names
     * @param list - collection of data comes from api
     */
    checkDuplicateRecord(list): any {
        let distintRecords = [];
        distintRecords.push(list[0]);
        // check for unique show string
        for (let i = 1; i < list.length; i++) {
            if (list[i].hasOwnProperty('showStr')) {
                if ((list[i].showStr).toLowerCase() !== (list[i - 1].showStr).toLowerCase()) {
                    distintRecords.push(list[i]);
                }
            } else if (list[i].hasOwnProperty('fullName')) {
                if ((list[i].fullName).toLowerCase() !== (list[i - 1].fullName).toLowerCase()) {
                    distintRecords.push(list[i]);
                }
            }
        }

        return distintRecords;
    }

    /**
     * Function create url and download the file
     * @param data - response body
     * @param fileName - name of the file to download
     */
    downloadFileFromBlob(data, fileName) {
        //for chrome of ios
        if (navigator.userAgent.match('CriOS')) {
            let fileData = [data];
            var reader = new FileReader();
            var blob = new Blob(fileData, { type: data.type });
            reader.onload = function (e) {
                window.location.href = reader.result
            }
            reader.readAsDataURL(blob);
        }
        // for IE and edge browser
        else if (window.navigator.msSaveOrOpenBlob) {
            let fileData = [data];
            let blobObject = new Blob(fileData);
            window.navigator.msSaveBlob(blobObject, fileName);
        }
        //for all other browser
        else {
            var a = document.createElement("a");
            document.body.appendChild(a);
            let url = window.URL.createObjectURL(data);
            a.href = url;
            a.download = fileName;//name of the file to download
            a.click();
            window.URL.revokeObjectURL(url);
        }
    }

    /**
     * Function find object by given attribute value, remove it from the list and return the updated list
     * @param arr - array/list
     * @param attr - name of the attribute to compare
     * @param value - value of the attribute to compare
     */
    removeByAttr(arr, attr, value) {
        var i = arr.length;
        while (i--) {
            if (arr[i]
                && arr[i].hasOwnProperty(attr)
                && (arguments.length > 1 && arr[i][attr] === value)) {
                arr.splice(i, 1);
            }
        }
        return arr;
    }

    /**
     * Function find object by given attribute value, update it in the list and return the updated list
     * @param arr - array/list
     * @param attr - name of the attribute to compare
     * @param value - value of the attribute to compare
     * @param updatePropName - attribute name to update
     * @param updatePropVal - attribute value to update
     */
    updateByAttr(arr, attr, value, updatePropName: any, updatePropVal: any) {
        var i = arr.length;
        while (i--) {
            if (arr[i]
                && arr[i].hasOwnProperty(attr)
                && (arguments.length > 1 && arr[i][attr] === value)) {
                arr[i][updatePropName] = updatePropVal;
            }
        }
        return arr;
    }

    isNull(val) {
        if (val == undefined || val == null || val == '' || val == 0 || val == [])
            return true;
        return false;
    }

    /**
     * Log out function when click on log out button
     * If you don't want to redirect on other URL then pass param : redirect = false
     */
    logoutUser(redirect: boolean = true, eCode: string = null) {
        localStorage.clear();
        this._appGlobals.accessToken.next(null);
        this._appGlobals.isUserLoggedIn.next(false);
        let logoutURL = this._appGlobals.logoutURL.getValue();
        this._appGlobals.userInfo.next(null);
        if (this._appGlobals.isInternalUser) {
            this._appGlobals.routeWithID = true; // make this property true so that routes only activate when comes from internal User logout click only
            this._router.navigate(['Logout']);
        } else {
            if (redirect && logoutURL) {
                window.location.href = logoutURL;
            } else {
                this.setUserLoggedInStatus(false);
                if (eCode != null && eCode != "") {
                    this._router.navigate(['**', { eid: eCode }]);
                } else {
                    this._router.navigate(['**']);
                }
            }
        }
    }

    /**
     * For auto complete fields if entered value is not selected from dropdown then disable search button
     * @param form -  instance of Form
     * @param otherFields  - pass array of fields which are not auto complete field (Like text fields)
     * @param isDefaultEnable - pass true to enable search by default and false to conditional enable search button
     */
    searchDisable(form: any, otherFields: any = [], isDefaultEnable: boolean): boolean {
        let isSearchDisable = true;
        let keys = Object.keys(form);
        let values = this.objValues(form);
        for (let i = 0; i < values.length; i++) {
            let value = values[i];
            if (value) {
                if ((value.id || otherFields.indexOf(keys[i]) > -1)) {
                    isSearchDisable = false;
                } else {
                    isSearchDisable = true;
                    break;
                }
            }
            else if (isDefaultEnable) {
                isSearchDisable = false;
            }
        }
        return isSearchDisable;
    }

    //hide notification dropdown for candidate when clicked from outside
    toggle_class() {
        if (this.toggle_my_Class.toLowerCase() == "active") {
            this.toggle_my_Class = 'inactive';
        }
    }

    /**
      * used to farmat input text
      * @param input - input value passed that needs to be formatted
      * @param breakPoint - Number at which separator is appended
      * @param sep - separator that is appended
      */
    textFormat(input, breakPoint, sep) {

        input = input.replace(/-/g, "");
        let output = "";
        let idx = 0;
        for (let i = 0; idx < input.length; i++) {
            output += input.substr(idx, breakPoint);
            if (idx + breakPoint < input.length) output += sep;
            idx += breakPoint;
        }
        output += input.substr(idx);
        return output;
    }

    getCandidateEmail():any {
      if(this.isAdminAsCandidate()) {
        return this._appGlobals.candidateEmail;
      }

      return this._appGlobals.userInfo.getValue().email;
    }

    getUserRole():any {
      return this._appGlobals.userInfo.getValue().userRole
    }

    isAdminAsCandidate():boolean {
      return Boolean(this._appGlobals.userId);
    }

    adminBecomeCandidate(id: any, email: any) {
      this._appGlobals.userId = id;
      this._appGlobals.candidateEmail = email;
    }

    adminUnbecomeCandidate() {
      this._appGlobals.userId = 0;
      this._appGlobals.candidateEmail = null;
    }

    effectiveExamStatusIs(exam, status) {
      let statusMapping = {
        COMPLETED: "COMPLETED",
        EXAMSEXPIRED: "EXAMSEXPIRED",
        EXAMSTOSCHEDULE: "EXAMSTOSCHEDULE",
        NOSHOW: "COMPLETED",
        RESCHEDULED: "SCHEDULED",
        SCHEDULED: "SCHEDULED",
      };
      return statusMapping[exam.status.toUpperCase()]==status.toUpperCase();
    }

    effectiveExamStatusIsIn(exam,statuses) {
      for (let status of statuses) {
        if (this.effectiveExamStatusIs(exam, status)) {
          return true;
        }
      }

      return false;
    }

    usesVirtualLocation(exam?){
      return exam && exam.usesVirtualLocation;
    }

    //
    // Custom Exam Style Classes
    //

    examModelRow1CSSClass(exam?) {
      return (exam && exam.examType || 'ue').toLowerCase() + 'ExamModelRow1';
    }

    examScheduleDetailListSecCSSClass(exam?) {
      return (exam && exam.examType || 'ue').toLowerCase() + 'ExamScheduleDetailListSec';
    }

    examBackgroundCSSClass(exam?) {
      return (exam && exam.examType || 'ue').toLowerCase() + 'ExamBackground';
    }

    examNameCSSClass(exam?) {
      return (exam && exam.examType || 'ue').toLowerCase() + 'ExamName';
    }

    examBorderBottomCSSClass(exam?) {
      return (exam && exam.examType || 'ue').toLowerCase() + 'ExamBorderBottom';
    }

    //
    // End Custom Exam Style Classes
    //

    getExamTypeDisplay(examType) {
        const matchingExamType: any = examTypeOptions.find(examTypeOption => examTypeOption.examType == examType);
        return null === matchingExamType ? "" : matchingExamType.name;
    }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/Services/utility.ts